<template>
  <div>
    <DataTable
      ref="DataTable"
      :data-model="'customers'"
      :display-name-plural="$t('entities.Customer.Plural')"
      :display-name-singular="$t('entities.Customer.Singular')"
      :permission-name="'Customers'"
      :allow-delete="isAdmin"
      :remove-message="$t('DeleteCustomer.RemoveMessage')"
      :remove-path="'/admin/customers/deletecustomer'"
      :exclude-fields="['id', 'address',
                        'agreedToDataProcessing',
                        'agreedToTermsOfService',
                        'agreedToDNAAnalysis',
                        'reservationStatus',
                        'dnaSampleUsageStatus',
                        'agreedToSampleBeingUsedForScientificPurposes',
                        'agreedToSampleExamination',
                        'dnaAgreementWasDigital',
                        'barcodeAssignable',
                        'registrationSource',
                        'notifyByEmail',
                        'notifyBySms',
                        'noSampleAvailable']"
      :formatter="{phone: (phone) => phone.prefix+phone.number}">
      <template #cell(isUserLoginActive)="row">
        <b-form-checkbox v-model="row.item.isUserLoginActive"
                         :disabled="true" />
      </template>
      <template #extraActions="row">
        <el-tooltip
          :content="'Přiradit čárový kód'"
          :enterable="false"
          placement="top"
          v-if="$auth.check(
            'Permissions.AdminPanel.Customers.Edit'
          ) && row.item.barcodeAssignable">
          <b-button class="downloadBtn mx-1"
                    @click="$refs.scanModal.show(); currentlyScanning = row.item.id; $barcodeScanner.init(scanBarcode)">
            <font-awesome-icon class="fa-xs"
                               icon="barcode" />
          </b-button>
        </el-tooltip>
        <el-tooltip
          :content="$t('common.CreateSample')"
          :enterable="false"
          placement="top"
          v-if="$auth.check(
            'Permissions.AdminPanel.Customers.Edit'
          ) && row.item.noSampleAvailable">
          <b-button class="createSampleBtn mx-1"
                    @click="customerId = row.item.id; $refs.createSampleModal.show();">
            <font-awesome-icon class="fa-xs"
                               icon="vial" />
          </b-button>
        </el-tooltip>
      </template>
    </DataTable>
    <b-modal id="modal-center"
             ref="scanModal"
             centered
             :static="true">
      <template #modal-header>
        <div class="d-flex justify-content-center w-100 text-center">
          <h3>
            {{ $t('common.ScanBarcode') }}
          </h3>
        </div>
      </template>
      <template #modal-footer="{ cancel, ok }">
        <b-button
          variant="danger"
          @click="$refs.scanModal.hide(); currentlyScanning = 0; $barcodeScanner.destroy()">
          {{ $t('common.Cancel') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-center"
             ref="createSampleModal"
             centered
             :static="true">
      <template #modal-header>
        <div class="d-flex justify-content-center w-100 text-center">
          <h3>
            {{ $t('common.CreateSample') }}
          </h3>
        </div>
      </template>
      <p class="my-4 text-center">
        {{ $t('common.RealyCreateSampleQuestion') }}
      </p>
      <template #modal-footer="{ cancel, ok }">
        <b-button
          variant="secondary"
          @click="customerId = null; $refs.createSampleModal.hide();">
          {{ $t('common.Cancel') }}
        </b-button>
        <b-button
          variant="danger"
          @click="createSample();">
          {{ $t('common.Yes') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import DataTable from '@components/admin/DataTable';

export default {
  components: {
    DataTable
  },
  data() {
    return {
      currentlyScanning: 0
    };
  },
  computed: {
    role() {
      return this.$store.state['vue-auth']?.user?.role || '';
    },
    isAdmin() {
      return this.role === 'Administrator';
    }
  },  
  methods: {
    scanBarcode(code) {
      this.axios.post('admin/barcodes/assign', {
        CustomerId: this.currentlyScanning,
        Code: code
      }).then((response) => {
        this.$refs.DataTable.refresh();
        this.$root.$bvToast.toast('Čárový kód úspěšně přirazen', {
          title: 'Úspěch',
          variant: 'success',
          toaster: 'b-toaster-top-right'
        });
        Promise.resolve(response);
      }).catch((err) => {
        this.$root.$bvToast.toast('Nepodařilo se přiradit čárový kód', {
          title: 'Nepodařilo se přiradit',
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
        Promise.reject(err);
      });
    },
    createSample() {
      this.axios.put('/admin/customers/createsample', {
        CustomerId: this.customerId
      }).then(() => {
        this.$root.$bvToast.toast(this.$t('CreateSample.SuccessToast.Body'), {
          title: this.$t('CreateSample.SuccessToast.Title'),
          variant: 'success',
          toaster: 'b-toaster-top-right'
        });
        this.customerId = null;
        this.$refs.createSampleModal.hide();
        this.$router.push({ name: 'admin.customers.samples.view' });
      }).catch(() => {
        this.$root.$bvToast.toast(this.$t('CreateSample.FailToast.Body'), {
          title: this.$t('CreateSample.FailToast.Title'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
        this.customerId = null;
        this.$refs.createSampleModal.hide();
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@colors';
.downloadBtn {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background-color: #c95328;
  color: $text-on-secondary;
  border: none;
  &:hover {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    background-color: darken($secondary-variant-color, 10%);
    color: $text-on-secondary;
  }
}
.createSampleBtn {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background-color: #8FBC8F;
  color: $text-on-secondary;
  border: none;
  &:hover {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    background-color: darken(#8FBC8F, 10%);
    color: $text-on-secondary;
  }
}
</style>
